module.exports = __webpack_public_path__ + "img/luxury-products-icon.4fdb23e065b8fe9c0af9e5b507f2d8de.svg";